import React, { useContext } from "react"
import lodash from "lodash"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"

import Field from "components/Field"
import Select from "components/Select"
import { useCustomer } from "components/Customer"

const connectRedux = connect(createStructuredSelector({}), {})

const SlaSelect = props => {
  const { currentCustomer } = useCustomer()

  const options = lodash
    .keys(lodash.get(currentCustomer, "activeSlaList", {}))
    .map(id => {
      return {
        value: id,
        label: lodash.get(currentCustomer, ["activeSlaList", id])
      }
    })

  return (
    <Field name="slas" label={i18n.t("SLAs", "SLAs")}>
      <Select direct options={options} isMulti={true} />
    </Field>
  )
}

export default connectRedux(SlaSelect)
